import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ConceptocomisionesComponent } from './components/conceptocomisiones/conceptocomisiones.component';
const routes: Routes = [
  {path: 'conceptocomisiones', component: ConceptocomisionesComponent},
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ConceptocomisionesRoutingModule { }
